import _ from 'lodash'

const listToTree = (list, idStr, pidStr, childrenStr) => {
  let result = []
  if (!list || list.length <= 0) {
    return result
  }
  let hash = {}
  let id = idStr || 'id'
  let pid = pidStr || 'pid'
  let children = childrenStr || 'children'
  list = _.sortBy(list, pid)
  let len = list.length
  let i = 0
  for (i = 0; i < len; i++) {
    hash[list[i][id]] = JSON.parse(JSON.stringify(list[i]))
    hash[list[i][id]]['depth'] = 0
    hash[list[i][id]]['leaf'] = true
  }
  for (i = 0; i < len; i++) {
    let aVal = hash[list[i][id]]
    let hashVP = hash[aVal[pid]]
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = [])
      aVal['depth'] = hashVP['depth'] + 1
      hashVP[children].push(aVal)
      hashVP['leaf'] = false
    } else {
      aVal['depth'] = 0
      result.push(aVal)
    }
  }
  return result
}

const listToReply = (list, idStr, pidStr, childrenStr) => {
  let result = []
  if (!list || list.length <= 0) {
    return result
  }
  let hash = {}
  let id = idStr || 'id'
  let pid = pidStr || 'pid'
  let children = childrenStr || 'children'
  list = _.sortBy(list, pid)
  let len = list.length
  let i = 0
  for (i = 0; i < len; i++) {
    hash[list[i][id]] = _.cloneDeep(list[i])
  }
  for (i = 0; i < len; i++) {
    let aVal = hash[list[i][id]]
    let hashVP = hash[aVal[pid]]
    if (hashVP) {
      let hashPP = hash[hashVP[pid]]
      if (!hashPP) {
        !hashVP[children] && (hashVP[children] = [])
        hashVP[children].push(aVal)
        continue
      }
      while (hashPP) {
        hashVP = hashPP
        hashPP = hash[hashVP[pid]]
      }
      !hashVP[children] && (hashVP[children] = [])
      hashVP[children].push(aVal)
    } else {
      result.push(aVal)
    }
  }
  return result
}

const findMultipleChildParentFromTree = (tree, childrenStr) => {
  if (!tree || tree.length <= 0) {
    return null
  }
  var children = childrenStr || 'children'
  function fn (node) {
    let list = node ? node[children] : tree
    if (_.isEmpty(list)) {
      return {}
    }
    if (list.length > 1) {
      return node || {}
    }
    if (!list[0][children] || _.isEmpty(list[0][children])) {
      return node
    }
    return fn(list[0])
  }
  return fn()
}

const findItemFromTree = (tree, match, idStr, childrenStr) => {
  if (!match) {
    return null
  }
  if (!tree || tree.length <= 0) {
    return null
  }
  var id = idStr || 'id'
  var children = childrenStr || 'children'
  function fn (node) {
    if (node && node[id] === match) {
      return node
    }
    let list = node ? node[children] : tree
    if (list && list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        let item = fn(list[i])
        if (item) {
          return item
        }
      }
    } else {
      return null
    }
  }
  return fn()
}

const findFromTree = (tree, match, idStr, childrenStr) => {
  var path = []
  if (!match) {
    return path
  }
  if (!tree || tree.length <= 0) {
    return path
  }
  var id = idStr || 'id'
  var children = childrenStr || 'children'
  function fn (node) {
    if (node) {
      path.push(node)
      if (node[id] === match) {
        throw (new Error('success'))
      }
    }
    let list = node ? node[children] : tree
    if (list && list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        fn(list[i])
      }
      path.pop()
    } else {
      path.pop()
    }
  }
  try {
    fn()
  } catch (e) {
    return path
  }
  return path
}

const findIdFromTree = (tree, match, idStr, childrenStr) => {
  var path = []
  if (!match) {
    return path
  }
  if (!tree || tree.length <= 0) {
    return path
  }
  var id = idStr || 'id'
  var children = childrenStr || 'children'
  function fn (node) {
    if (node) {
      path.push(node[id])
      if (node[id] === match) {
        throw (new Error('success'))
      }
    }
    let list = node ? node[children] : tree
    if (list && list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        fn(list[i])
      }
      path.pop()
    } else {
      path.pop()
    }
  }
  try {
    fn()
  } catch (e) {
    return path
  }
  return path
}

const findDescendantFromTree = (root, idStr, childrenStr) => {
  var ids = []
  if (!root) {
    return ids
  }
  var id = idStr || 'id'
  var children = childrenStr || 'children'
  function fn (node) {
    if (node) {
      ids.push(node[id])
    }
    let list = node[children]
    if (!list || list.length <= 0) {
      return
    }
    for (let i = 0; i < list.length; i++) {
      fn(list[i])
    }
  }
  fn(root)
  return ids
}

export default {
  listToTree,
  listToReply,
  findItemFromTree,
  findMultipleChildParentFromTree,
  findFromTree,
  findIdFromTree,
  findDescendantFromTree
}
